export default "__VITE_ASSET__D7GPyG1z__";